if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      // limit: 22,
      loadProductFirst: false,
      numberFilterTree: 2,
      selectOptionContainer: '.grid__item .card-wrapper',
      stickyFixTopPos: true,
    },
    selector: {
      otpTopCartCount: '.cart-count-bubble'
    }
  };
}

(function () {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


  BoostPFS.inject(this);
  /* For Filter Setting Layout */
  Selector.stickyElementDesktop = jQ('.boost-pfs-filter-left-col').length > 0 && !Utils.isMobile() ? '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';
  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;


    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Custom class
    boostPFSTemplate.soldOutLabelHtml=`<span class="soldout-badge badge badge--bottom-left color-{{soldOutBadgeClass}}" aria-hidden="true">\n  TEMPORARILY OUT OF STOCK\n</span>`
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    var saleClass = onSale ? boostPFSTemplate.saleClass : '';
    var ratioImage = getRatioImage(data);
    var imageAspectRatio = ratioImage / getAspectRatio(data.images_info[0]) * 100;

    itemHtml = itemHtml.replace(/{{imageAspectRatio}}/g, imageAspectRatio);
      
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);


    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add Card product class
    itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass(data));
    // Add Card inner product class
    itemHtml = itemHtml.replace(/{{cardInnerProductClass}}/g, buildCardInnerProductClass(data));
    // Add Card badge position
    itemHtml = itemHtml.replace(/{{cardBadgePosition}}/g, boostPFSThemeConfig.custom.badge_position);
    // Add check card heading five
    itemHtml = itemHtml.replace(/{{cardIsHeadingFive}}/g, buildCardIsHeadingFive(data));
    // Add sold out Label
    itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel(data));
    // Add sale Label
    itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel(data));
    // Add top left badge
    itemHtml = itemHtml.replace(/{{cardBadgeTopLeft}}/g, buildCardBadgeTopLeft(data));
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
    //Swatch size 
    itemHtml = itemHtml.replace(/{{swatchSize}}/g, buildswatchSize(data));
    /* Swym integration */
    var itemWishlistHtml = '<button class="swym-button swym-add-to-wishlist-view-product product_{{itemId}}" data-swaction="addToWishlist"  data-product-id="' + JSON.stringify(data.id) + '"></button>';
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);
    

    // Add Review
    if (typeof Integration === 'undefined' ||
      (typeof Integration != 'undefined' &&
        typeof Integration.hascompileTemplate == 'function' &&
        !Integration.hascompileTemplate('reviews'))) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    // Add Description
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, boostPFSThemeConfig.custom.description || '');

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, addtowishlist_heart_icon(data));
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

    itemHtml = itemHtml.replace(/{{productSwatches}}/g, buildProductSwatches(data));

    // add promotion call out and custom badges
    if(data.available) {
      itemHtml = itemHtml.replace(
        /{{promotionalCallouts_Price}}/g,
        buildPromotionalCalloutsPrice(data)
      );

      itemHtml = itemHtml.replace(/{{itemProductBadges}}/g, buildProductBadges(data));
      itemHtml = itemHtml.replace(/{{itemPromoCallouts}}/g, buildPromotionalCallouts(data));
      
    } else {
      itemHtml = itemHtml.replace(/{{itemPromoCallouts}}/g, "");
      itemHtml = itemHtml.replace(
        /{{promotionalCallouts_Price}}/g,
        ""
      );
      // If product has coming-soon tag, show badges
      if (data.tags && data.tags.some(tag => tag.toLowerCase() === 'coming-soon')) {
        itemHtml = itemHtml.replace(/{{itemProductBadges}}/g, buildProductBadges(data));
      } else {
        itemHtml = itemHtml.replace(/{{itemProductBadges}}/g, "");
      }
    }
    return itemHtml;
  };

  function buildProductBadgeMetaobject(data, key) {
    let result = [];
    if (!key) return result;

    const metaobject = data.metafields.find(item => item.key === key);
    if (!metaobject) return result;

    const metaobjectData = JSON.parse(metaobject.value);

    // Transform fields array into object with key-value pairs
    if (Array.isArray(metaobjectData)) {
      metaobjectData.forEach((item) => {
        if (item.data && Array.isArray(item.data.fields)) {
          const obj = {};
          item.data.fields.forEach((field) => {
            obj[field.key] = field.jsonValue;
          });
          result.push(obj);
        }
      });
    }
    return result;
  }

  function buildPromotionalCalloutsPrice(data) {
    const metaobject = buildProductBadgeMetaobject(data, "promo_callouts");
    let afterPrice = '';
    const priceBadges = metaobject.filter(item => item.position == "Below Price");
    console.log("priceBadges", priceBadges);
    if(priceBadges.length == 0) return '';
    priceBadges.forEach(item => {
      afterPrice += `<${item.link ? 'a' : 'div'} href="${item.link}" class="product-badge  promotion" style="background-color:${item.background_colour};color:${item.text_colour};">
      ${item.text}</${item.link ? 'a' : 'div'}>`;
    });
    return afterPrice;
  }

  function buildProductBadges(data) {
    const metaobject = buildProductBadgeMetaobject(data, "badges");
    if(!metaobject || metaobject.length == 0) return '';
    console.log("metaobject", metaobject);
    let topLeftHtml = '<div class="product-badges top-left">';
    let topRightHtml = '<div class="product-badges top-right">';
    console
    metaobject.forEach(item => {
      if(item?.position?.toString()?.toLowerCase()?.includes("left")) {
        topLeftHtml += `<${item.link ? 'a' : 'div'} href="${item.link}" class="product-badge top-left" style="background-color:${item.background_colour};color:${item.text_colour};">
        ${item.text}</${item.link ? 'a' : 'div'}>`;
      } else if(item?.position?.toString()?.toLowerCase()?.includes("right")) {
        topRightHtml += `<${item.link ? 'a' : 'div'} href="${item.link}" class="product-badge top-right" style="background-color:${item.background_colour};color:${item.text_colour};">
        ${item.text}</${item.link ? 'a' : 'div'}>`;
      }
    });
    topLeftHtml += '</div>';
    topRightHtml += '</div>';
    return topLeftHtml  + topRightHtml;
  }

  function buildPromotionalCallouts(data) {
    const metaobject = buildProductBadgeMetaobject(data, "promo_callouts");
    if(!metaobject || metaobject.length == 0) return '';
    let html = '';
    metaobject.filter(item => !item.position.toString().toLowerCase().includes("price")).forEach(item => {
      html += `<${item.link ? 'a' : 'div'} href="${item.link}" class="product-badge bottom promotion" style="background-color:${item.background_colour};color:${item.text_colour};">
      ${item.text}</${item.link ? 'a' : 'div'}>`;
    });
    return html;
  }

  function buildProductSwatches(data) {
		const productSwatchesContainer = document.createElement('div');
		productSwatchesContainer.classList.add('product-swatches__container');

		const swatchesSettings = {
		  handle: data.handle,
		  image_type: 'metafield_colour',
		  data: JSON.stringify(data),
		  hideIfEmpty: true,
		  colour: data.metafields?.swatches?.colour_name ?? data.title,
		  selectedVariant: data.variants[0],
		  swatchOptions: ['color', 'size'],
		  colourTagPrefix: 'colour:',
		  swatchUrl: "",
		  currentCollection: "",
		  currentProductHandle: data.handle,
		  skipOneOption: false,
		  metafieldSwatch: data.metafields?.swatches?.image,
		  showVendor: (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') && boostPFSThemeConfig.custom.show_vendor === true)
		};
		
		const swatchesSettingsScript = document.createElement('script');
		swatchesSettingsScript.setAttribute('type', 'application/json');
		swatchesSettingsScript.setAttribute('data-swatches-settings', '');
		swatchesSettingsScript.innerHTML = JSON.stringify(swatchesSettings);
		
		const productSwatches = document.createElement('product-swatches');
		productSwatches.appendChild(productSwatchesContainer);
		productSwatches.appendChild(swatchesSettingsScript);

		return productSwatches.outerHTML;
	}

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildImages(data) {
    var html = '';

    var rangeWidths = (typeof boostPFSRangeWidths !== 'undefined' && boostPFSRangeWidths.length)
      ? boostPFSRangeWidths
      : [165, 360, 533, 720, 940, 1066];

    var dimW = (typeof images !== 'undefined' && images && images[0] && images[0].width) ? images[0].width : null;
    var dimH = (typeof images !== 'undefined' && images && images[0] && images[0].height) ? images[0].height : null;

    if (data && data.images && typeof data.images === 'object' && Object.keys(data.images).length > 0) {
      var imgAlt = data.title || 'Product image';
      var swiperClass = 'pfs-swiper-' + (data.id || Math.random().toString(36).slice(2));

      html += '<div class="card__media">';
      html += '<div class="media media--transparent media--hover-effect">';

      html += '<div class="swiper-media-product ' + swiperClass + '">';
      html += '<div class="swiper-wrapper">';

      Object.keys(data.images).forEach(function (key) {
        var url = data.images[key];

        var dataSrcSet = '';
        for (var i = 0; i < rangeWidths.length; i++) {
          dataSrcSet += Utils.optimizeImage(url, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
          if (i < rangeWidths.length - 1) dataSrcSet += ', ';
        }
        var src533 = Utils.optimizeImage(url, '533x');

        html += '<div class="swiper-slide">';
        html += '<img class="motion-reduce" ' +
                'loading="lazy" ' +
                'srcset="' + dataSrcSet + '" ' +
                'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" ' +
                'src="' + src533 + '" ' +
                (dimH ? ('height="' + dimH + '" ') : '') +
                (dimW ? ('width="' + dimW + '" ') : '') +
                'alt="' + imgAlt.replace(/"/g, '&quot;') + '" />';
        html += '</div>';
      });

      html += '</div>'; 
      html += '<div class="swiper-pagination"></div>';
      html += '<div class="swiper-button-prev"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="20" height="20" rx="10" fill="white"/><path d="M11.5 13L8.5 10L11.5 7" stroke="#414042" stroke-linecap="round" stroke-linejoin="round"/></svg></div>';
      html += '<div class="swiper-button-next"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="20" height="20" rx="10" fill="white"/><path d="M8.5 13L11.5 10L8.5 7" stroke="#414042" stroke-linecap="round" stroke-linejoin="round"/></svg></div>';
      html += '</div>'; // .swiper

      html += '</div>'; // .media
      html += '</div>'; // .card__media
    } else {
      // Fallback when no images
      html += '<div class="card__content">' +
                '<div class="card__information">' +
                  '<h3 class="card__heading">' +
                    '<a href="#" class="full-unstyled-link">' +
                      (data.title || '') +
                    '</a>' +
                  '</h3>' +
                '</div>' +
              '</div>';
    }
    return html;
  }
  function buildCardProductClass(data) {
    var html = '' + boostPFSThemeConfig.custom.card_style;
    if (!images) {
      html += ' card--text';
    } else {
      html += ' card--media';
    }
    if (boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (!images && boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardInnerProductClass(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardIsHeadingFive(data) {
    var html = '';
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html = 'h5';
    }
    return html;
  }

  function buildVendor(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
      boostPFSThemeConfig.custom.show_vendor === true) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }
  
  function buildswatchSize(data){
      var html = '';
    

   //  console.log(data);
    if ( data.options.length == 1  && data.variants.length>1){
      // console.log(data.handle)
    html = html+'<ul class="img_hove_sizes">'
     data.variants.forEach((variant)=>{
       if(variant.available){
         html=html+`<li class="available" onclick="addToCart(${variant.id},'${data.handle}')"><p >${variant.title}</p></li>`;
       }else{
       html=html+`<li class="soldout"><p>${variant.title}</p></li>`;
       }
     });
      html = html+'</ul>'
      
    }else if (data.options.length > 1) {
      var colorOption = data.options_with_values.filter(x => x.name == 'color' || x.name == 'Color')
      var colorOptionIndex = data.options.findIndex(x => x == 'color' || x == 'Color')

      data.options_with_values.forEach(x => {
        if(x.name == 'size' || x.name == 'Size') {
          html = html+'<ul class="img_hove_sizes">'
            data.variants.forEach((variant)=>{
              if(variant.options[colorOptionIndex] == colorOption[0].values[0].title) {
                if(variant.available){
                  html=html+`<li class="available" onclick="addToCart(${variant.id},'${data.handle}')"><p >${variant.option_size}</p></li>`;
                }else{
                html=html+`<li class="soldout"><p>${variant.option_size}</p></li>`;
                }
              }
  
            });

           html = html+'</ul>'
        }

      })
    }
    
    
    return html;
    
  }
  
  function addtowishlist_btn(data) { 

    /* Swym integration */
    var itemWishlistHtml = '<button class="swym-button swym-add-to-wishlist-view-product product_{{itemId}}" data-swaction="addToWishlist"  data-product-id="' + JSON.stringify(data.id) + '">Add to wishlist</button>';
    return itemWishlistHtml;
  }

  function addtowishlist_heart_icon(data) { 
    var itemWishlistHtml_heart = '<button class="swym-button swym-add-to-wishlist-view-product product_{{itemId}}" data-swaction="addToWishlist"  data-product-id="' + JSON.stringify(data.id) + '"></button>';
    return itemWishlistHtml_heart;
  }  

  function buildPrice(data) {
    var html = '';
    var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
    var priceAmount = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.price_min, 'money_with_currency') : Utils.formatMoney(data.price_min);
    var compareAtPrice = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.compare_at_price_min, 'money_with_currency') : Utils.formatMoney(data.compare_at_price_min);
    var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount) : priceAmount;
    var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
    html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}">
          <div class="price__container">
            <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span class="price-item price-item--regular">
                ${moneyPrice}
              </span>
            </div>
            <div class="price__sale">              
              <span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
              <span class="price-item price-item--sale price-item--last">
                ${moneyPrice}
              </span>
			 <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span>
                <s class="price-item price-item--regular">
                  ${compareAtPrice}
                </s>
              </span>
            </div>
            <small class="unit-price caption ${unitPriceClass}">
              <span class="visually-hidden">${boostPFSConfig.label.unit_price}</span>
              <span class="price-item price-item--last">
                <span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
                <span aria-hidden="true">/</span>
                <span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
              </span>
            </small>
          </div>
        </div>`
    return html;
  }

  function buildSoldOutLabel(data) {
    // Build Sold out label
    let html='';
    // Check if product has coming-soon tag, if so return empty (no badge)
    if (data.tags && data.tags.some(tag => tag.toLowerCase() === 'coming-soon')) {
      return '';
    }
if(!data.available){
  html=`<div class="out_of_stock_badge">Out Of Stock </div>`;
}
 else if(data.compare_at_price!=null){
   html=`<div class="sale_badge">Sale </div>`;
 } 
    else{
data.tags.forEach((tag)=>{
  if(tag.includes("badge")){
    const taginfo = tag.split(':');
html=`<div class="product_badge" style="background-color:${taginfo[2]}">${taginfo[1]}</div>`;    
  }                       });     
    }
    return html;
  }
  
  function buildCardBadgeTopLeft(data) {
    let html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('collection_badges')) {
      for (let i = 0; i < data['collections'].length; i++) {
        const existCollection = boostPFSThemeConfig.custom.collection_badges.filter(x => data['collections'][i].handle === x.badge_collection);
        if (existCollection && existCollection.length > 0) {
          html = `<div class="card__badge top left airweave">
<span class="badge badge-image airweave">
<img loading="lazy" src="${existCollection[0].badge_img}" alt="${data['collections'][i].title}" height="20" width="60" />
</span>
</div>`;
          break;
        }
      }    
    }
    return html;
  }

  function buildSaleLabel(data) {
    // Build Sale label
    // Check if product has coming-soon tag, if so return empty (no badge)
    if (data.tags && data.tags.some(tag => tag.toLowerCase() === 'coming-soon')) {
      return '';
    }
    const _data = {...data};
    var saleLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
      let xOff = (_data.compare_at_price_min - _data.price_min ) * 100 / _data.compare_at_price_min;

      if(!isNaN(xOff)) {
        if(xOff < 35) {
          xOff = 30
        } else if (xOff < 45) {
          xOff = 40
        } else if (xOff < 55) {
          xOff = 50
        } else {
          xOff = Math.round(xOff / 10) * 10;
        }
      }
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme).replace(/{{saleOff}}/g, xOff ? xOff + '% OFF' : 'Sale');
    }
    return saleLabel;
  }

  function buildReview(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
      boostPFSThemeConfig.custom.show_product_review == true && Utils.getProductMetafield(data, 'reviews', 'rating') !== null) {
      var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >=0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info.replace('{{ rating_value }}', ratingObj.value).replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${boostPFSConfig.custom.accent_icons}" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${ratingObj.value.scale_max}; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(data, 'reviews', 'rating_count')})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(data, 'reviews', 'rating_count')} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
    }
    return html;
  }
    
  function getAspectRatio(data) {
    var width = (data == null) ? '535' : data.width;
    var height = (data == null) ? '535' : data.height;

    return width / height;
  }

  function getRatioImage(data) {
    var ratio = 1;
    if (images && boostPFSThemeConfig.custom.media_size == 'portrait') {
      ratio = 0.8;
    } else if (images && boostPFSThemeConfig.custom.media_size == 'adapt') {
      ratio = getAspectRatio(data.images[0]);
    }
    if (ratio === 0 || ratio === null) {
      ratio = 1;
    }
    return ratio;
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || '';
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          var isSelected = ''
          if(paramSort == k) {
            isSelected = 'selected="selected"'
          }
          sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate());

    if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
      jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
    }

    var labelSort = '';
    var paramSort = Globals.queryParams.sort || '';
    var sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting;
    }

    jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
  }

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function() {
    jQ(Selector.topSorting + ' .facet-filters__sort').change(function(e) {
      e.preventDefault();
      FilterApi.setParam('sort', jQ(this).val());
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
    });
  };
  function getPageValue(queryString) {
    const params = new URLSearchParams(queryString);
    return params.get('page');
  }

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;
    // check page;
    /** Start Swym integration **/
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function(swat) { 
      // Wrap with callback for loading without additional checks
      var products = [];
      data.forEach(function(product) {
        var image_src = Utils.getFeaturedImage(product.images_info);
        var productCopy = product;
        productCopy.featured_image = image_src;
        productCopy.price = product.price_min; // Sometimes I need to multiply the price with 100
        productCopy.compare_at_price = product.compare_at_price_min; // Sometimes I need to multiply the price with 100
        products.push(productCopy);
      });
      swat.mapShopifyProducts(products); // Product mapped data to swym layer
      swat.initializeActionButtons('.boost-pfs-filter-products'); // Buttons can now be initialized
    });
    /** End Swym integration **/
    
    
    if(data.length>9)
      itemposition=8;
    else
      itemposition=data.length;
//   extra grid html  
    if(document.querySelectorAll('.image-text_grid_item').length==0 && boostPFSThemeConfig.custom.show_info_card){
     var extraItemHtml = `     
     <li class="grid__item image-text_grid_item">
              <div class="info_card">
                <a href="${boostPFSThemeConfig.custom.info_button_link}">
                  <img src="${boostPFSThemeConfig.custom.info_image}" class="info_img" loading="lazy"/>
                </a>
                ${boostPFSThemeConfig.custom.info_title && boostPFSThemeConfig.custom.info_desc && boostPFSThemeConfig.custom.info_footnote ?
                  `<div class="card_info_body">
                    <h2>${boostPFSThemeConfig.custom.info_title}</h2>
                    <span>${boostPFSThemeConfig.custom.info_desc}</span>
                    <p >${boostPFSThemeConfig.custom.info_footnote}</p>
                  </div>
                  `
                  :
                  ``
                }

              </div>
            </li>` ;
    }
    else{ var extraItemHtml="";}
    const el = document.querySelector(`ul#main-collection-product-grid > li:nth-child(${itemposition})`)
    if (el) el.insertAdjacentHTML('afterend', extraItemHtml);
//     extra grid html end
  requestAnimationFrame(() => initPfsSwipers(document));
  }
  function checkIsLastPage(current_page, total_product, product_per_page) {
    const total_pages = Math.ceil(total_product / product_per_page);
    return current_page >= total_pages;
  }

  // Build Additional Elements
  Filter.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;

    const current_page = getPageValue(window.location.search);
    const isLastPage = checkIsLastPage(current_page, data.total_product, 24);
    console.log('isLastPage', isLastPage);
    if(isLastPage) {
      document.body.classList.add('boost-last-page')
    } else {
      document.body.classList.remove('boost-last-page')
    }
    jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
  };

  /************************** END BUILD TOOLBAR **************************/
  ProductListSearchNoResult.prototype.afterRender = () => {

    let html = '<div class="grid grid--2-col grid--3-col-tablet grid--one-third-max grid--4-col-desktop grid--quarter-max" style="width:100%;">';


    window.collection_empties.forEach(x => {
        let anchor_tag = `
        <div class="grid__item"><div class="card-wrapper">
        <div class="card
                    card--standard
                     card--media
                    
                    
                    " style="--ratio-percent: 125.0%;">
          <div class="card__inner color-background-2 ratio" style="--ratio-percent: 125.0%;"><div class="card__media">
              <div class="media media--transparent media--hover-effect">
                       
                  <img src="${x.image.src}" sizes="
                              (min-width: 1400px) Liquid error (sections/collection-block-list line 85): divided by 0px,
                              (min-width: 750px) calc(100vw - 10rem),
                              calc(100vw - 3rem)" alt="" height="1017" width="3000" loading="lazy" class="motion-reduce">
                  
              </div>
            </div><div class="card__content">        
              <div class="card__information">
                <h3 class="card__heading">
                  <a href="" class="full-unstyled-link">Your collection's name

                  </a>
                </h3></div> 

            </div>
          </div>
           
          <div class="card__content">
            <div class="card__information">
              <h3 class="card__heading">${x.title}</h3>
              ${x.total_product} items
              <p class="collection-description"></p>
              <a href="/collections/${x.handle}" class="">View</a>
            </div>
          </div>
           
        </div>
      </div>

    </div>
        `

        html += anchor_tag;
    });

    html += '</div>'

    jQ('.product-list-no-search-result-text').after( jQ('<div class="collection-search-empty"></div>').html( html ) )
  }
})();

function initPfsSwipers(root = document) {
        
  const isMobile = window.innerWidth <= 768; 

  document.querySelectorAll('.product-url-link').forEach(link => {
    if (isMobile) {
      if (!link.hasAttribute('target')) {
      }
    } else {
      link.removeAttribute('target');
      link.removeAttribute('rel');
    }
  });
  if (typeof Swiper === 'undefined') return; // Swiper not loaded
  root.querySelectorAll('.swiper-media-product:not(.swiper-initialized)').forEach((el) => {
    const pagination = el.querySelector('.swiper-pagination');
    const next = el.querySelector('.swiper-button-next');
    const prev = el.querySelector('.swiper-button-prev');

    const opts = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      watchSlidesProgress: true,
      centeredSlides: true,
      roundLengths: true,
      // Optional: disable navigation on mobile
      breakpoints: {
        0: {
          navigation: false,
        },
        1024: {
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        },
      }
    };
    if (pagination) opts.pagination = { el: pagination, clickable: true };
    if (next && prev) opts.navigation = { nextEl: next, prevEl: prev };

    new Swiper(el, opts);
  });
}

document.addEventListener('DOMContentLoaded', () => initPfsSwipers());
